import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-no-filters-available',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="flex flex-col items-center justify-center p-8 text-center">
      <mat-icon class="text-gray-400 mb-2" style="font-size: 48px; width: 48px; height: 48px;">
        filter_alt_off
      </mat-icon>
      <p class="text-gray-600 dark:text-gray-400">
        No hay filtros disponibles para este módulo.
      </p>
    </div>
  `,
  styles: []
})
export class NoFiltersAvailableComponent {}
